module.exports = __webpack_public_path__ + "static/media/file-default.7fb4e82a.svg";